import React, { useEffect, useState } from 'react'
import AddNewGroup from './AddNewGroup';
import spinner from "../../images/reports-spinner.gif";

export default function AccountLedgerGroup() {
  const [modal, setModal] = useState(false);
  const [editData, setEditData] = useState();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const close = () => setModal(!modal);

  useEffect(() => {
    setLoading(true);
    const getLedgerGroups = async () => {
      const json = {
        outlet_uuid: localStorage.getItem("outlet_uuid"),
      }
      const url = `https://api.myfooddo.com/acLedgerGroup/ListLedgerGroup`;
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(json),
      })
        .then(res => res.json())
        .then(data => {
          setTableData(data);
          setLoading(false);
        })
        .catch(err => console.warn("post request failed", err));
    }
    getLedgerGroups();
  }, [modal])

  return (
    <div className="accountGroup">
      <h1>Group</h1>
      <div className="accountGroupOptions">
        <button onClick={() => setModal(!modal)}>+Add New</button>
        <input type="search" placeholder="Search..." />
      </div>

      {loading && <div id="reports-loading-spinner" style={{ top: '87px', zIndex: '1' }}>
        <img src={spinner} alt="loading reports" />
      </div>}
      {!loading && <div className="items_table" style={{ flex: '1', padding: '0 10px' }}>
        <table className="f6 w-100 center" cellSpacing="0">
          <thead className="lh-copy">
            <tr className="white">
              <th className="pa2 bb b--black-20 w-50">Name</th>
              <th className="pa2 bb b--black-20 w-50">Action</th>
            </tr>
          </thead>
          <tbody className="lh-copy">
            {tableData.length > 0 && tableData?.map((data, i) => {
              if (data.ledger_group_uuid)
                return <tr key={i.toString()}>
                  <td className="ph4 pv1 tc bb b--black-20 bg-white">{data.ledger_group_title}</td>
                  <td className="ph4 pv1 tc bb b--black-20 bg-white">
                    <button
                      className='editButton'
                      onClick={() => {
                        setModal(!modal);
                        setEditData(data);
                      }}
                    >Edit</button>
                  </td>
                </tr>
              else return ''
            })}
          </tbody>
        </table>
      </div>}

      {modal && (
        <AddNewGroup
          type={!editData ? "New" : "Edit"}
          close={close}
          editData={editData}
        />
      )}
    </div>
  )
}
